import { Component, ElementRef, OnInit, ViewEncapsulation, OnDestroy, EventEmitter, Output, Input, OnChanges, AfterViewInit } from '@angular/core';
import { PageLoaderService } from "app/services/index";
import { HttpClient } from '@angular/common/http';
import { ServerPagingResult, GridV2Dto, GridColumnV2Dto } from '@hub/generated/models';
import { AGHyperlinkComponent } from './grid-components/g-hyperlink/g-hyperlink.component';
import { eColumnType } from '@hub/generated/enums';
import { AGCurrencyRendererComponent } from './grid-components/g-currency/g-currency.component';
import { Constants } from '@hub/common/Constants';


@Component({
  selector: 'main-grid-content',
  templateUrl: 'main-grid-content.component.html',
  styleUrls: ['./main-grid-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MainGridContentComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  private static readonly hyperlinkRendererKey = 'hyperlinkRenderer';
  private static readonly currencyRendererKey = 'currencyRenderer';

  public gridApi;
  public gridColumnApi;
  public columnDefs = [];
  public rowData;
  public frameworkComponents;
  public defaultColDef;
  public rowSelection;
  public paginationPageSize;
  public oldPaginationPageSize: number = 0;
  public firstLoad: boolean = false;
  public startRow: number;
  public endRow: number;
  public gridWidth: number = 0;
  public currentPage: number = 0;
  public totalPages: number = 0;
  public totalCount: number = 0;
  public newColumnSettings: GridColumnV2Dto[] = [];
  public oldGridId: string;
  public wrapperWidth: any;
  public totalGridColumns: number = 0;
  public isViewChanged: boolean = false;
  public rowHeight: string = "32px";


  @Input() data: ServerPagingResult<any>;
  @Input() RowsPerPage: Number[];
  @Input() IsGridEdit: boolean = false;
  @Input() grid: GridV2Dto;
  @Input() columns: GridColumnV2Dto[];
  @Input() isGridChanged: boolean = false;

  @Output() gridColumnSettings: EventEmitter<any> = new EventEmitter();
  @Output() onLazyLoad: EventEmitter<any> = new EventEmitter();
  @Output() columnSettingChange: EventEmitter<any> = new EventEmitter();
  @Output() onGridChangeCompleted: EventEmitter<any> = new EventEmitter();

  constructor(
    private hostElement: ElementRef<HTMLElement>,
    protected pageLoaderService: PageLoaderService,
    protected http: HttpClient,
  ) {
    this.frameworkComponents = {
      [MainGridContentComponent.hyperlinkRendererKey]: AGHyperlinkComponent,
      [MainGridContentComponent.currencyRendererKey]: AGCurrencyRendererComponent,
    };

    this.defaultColDef = {
      minWidth: Constants.COLUMN_MINIMUM_WIDTH,
      sortable: true,
      resizable: true,
      filter: false,
      cellClassRules: {
        'non-editable-class': function (params) { return !params.colDef.editable },
        'editable-class': function (params) { return params.colDef.editable },
      },
      domLayout: "autoHeight"
    }
    this.paginationPageSize = Constants.MAIN_GRID_PAGE_SIZE;
  }

  isLeftShow: boolean = false;
  isRightShow: boolean = false;

  ngOnInit() {

  }

  ngAfterViewInit() {
    var wrapper = this.getGridElement("ag-root-wrapper-body");

    if (!wrapper) {
      return;
    }

    this.wrapperWidth = wrapper.clientWidth;
  }

  ngOnChanges() {
    if (this.grid && this.grid.Columns && (!this.firstLoad || this.IsGridEdit || this.isGridChanged)) {

      if(this.oldGridId != this.grid.Id) {
        this.rowData = [];
        this.oldGridId = this.grid.Id;
        this.onGridChangeCompleted.emit();
        this.columns = this.grid.Columns;
      } else if (this.columns.length > 0) {
        this.grid.Columns = this.columns;
      }

      this.columnDefs = [];
      this.gridWidth = 0;
      this.totalGridColumns = 0;

      if (this.firstLoad) {
        this.gridApi.setColumnDefs([]);
      }

      this.grid.Columns.forEach(data => {
        if (data && data.Header) {
          this.gridWidth += data.IsHidden ? 0 : data.Width
          this.totalGridColumns++;
        }
      });

      this.grid.Columns.forEach(data => {
        var cellRenderer = undefined;

        if (data) {
          if (data.ColumnType == eColumnType.Hyperlink) {
            cellRenderer = MainGridContentComponent.hyperlinkRendererKey;
          } else if (data.ColumnType == eColumnType.Currency) {
            cellRenderer = MainGridContentComponent.currencyRendererKey;
          }

          if (data.Header) {
            var value = {
              headerName: data.Header,
              field: data.Field,
              colId: data.Header,
              width: (this.wrapperWidth > this.gridWidth) ? this.wrapperWidth / this.totalGridColumns : data.Width,
              editable: data.IsEditable,
              sort: data.Sort,
              pinned: data.Pinned,
              hide: data.IsHidden,
              cellClass: data.ColumnType == eColumnType.Currency ? "text-align-right" : ""
            };
            this.applyFrameworkRenderer(value, cellRenderer);
            this.columnDefs.push(value);
          }
        }
      })

      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.columnDefs);
      }
      if(this.isGridChanged){
        this.isLeftShow = false;
        this.isRightShow = false;
      }
    }

    if (this.data && this.data.Data) {
      this.rowData = this.data.Data;
      this.totalPages = this.data.TotalCount / this.paginationPageSize;
      this.totalCount = this.data.TotalCount;

      if (Number(this.totalPages) === this.totalPages && this.totalPages % 1 !== 0) {
        this.totalPages = parseInt(this.totalPages.toString()) + 1;
      }
      if (!this.firstLoad) {
        this.startRow = 0;
        this.endRow = this.paginationPageSize + 0 > this.data.TotalCount ? this.data.TotalCount : this.paginationPageSize + 0;
        this.firstLoad = true;
      } else {
        this.startRow = this.paginationPageSize * this.currentPage;
        this.endRow = this.startRow + this.paginationPageSize > this.data.TotalCount ? this.data.TotalCount : this.startRow + this.paginationPageSize;
      }
    }


  }

  private applyFrameworkRenderer(columnDef: any, renderer: any) {
    if (!renderer) {
      return;
    }

    columnDef.cellRenderer = renderer;
  }

  ngOnDestroy() {

  }


  backClick(isToFirstPage: boolean = false) {
    this.currentPage = isToFirstPage ? 0 : --this.currentPage;

    this.lazyLoadData();
  }

  forwardClick(isToLastPage: boolean = false) {
    this.currentPage = isToLastPage ? this.totalPages - 1 : ++this.currentPage;

    this.lazyLoadData();
  }

  getRowData() {
    let rowData = [];
    this.gridApi.forEachNode(node => rowData.push(node.data));
    return rowData;
  }

  gridColumnsChanged() {
    var gridColumns = this.gridColumnApi ? this.gridColumnApi.getAllGridColumns() || [] : [];
    var displayedColumns = this.gridColumnApi ? this.gridColumnApi.getAllDisplayedColumns() || [] : [];
    var hiddenHeaderOrder = displayedColumns.length;

    var columnSettings = this.columns.length > 0 ? this.columns : this.grid.Columns;

    columnSettings.forEach(x => {
      if (x) {
        var filterData = gridColumns.filter(y => y.colId == x.Header)[0];
        if (filterData) {
          x.IsHidden = !filterData.isVisible();
          x.Sort = filterData.getSort() == undefined ? null : filterData.getSort();
          x.Pinned = filterData.getPinned();
          x.Width = filterData.getActualWidth();
          x.Sorting = x.Header == null ? 0 : 1;
        }

        var sortData = displayedColumns.filter(y => y.colId == x.Header)[0];
        x.Order = sortData ? displayedColumns.indexOf(sortData) + 1 : ++hiddenHeaderOrder;
      }

      hiddenHeaderOrder = ++hiddenHeaderOrder;
    })

    return columnSettings;
  }

  setHiddenColumns(data: any) {
    this.gridColumnSettings.forEach(x => {
      var filterData = data.filter(y => y.colId == x.field);
      if (!filterData) {
        x.hide = true;
      }
    })
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.hideOverlay();
  }

  onPageSizeChanged(event: any) {

    var value = event.target.value;
    this.oldPaginationPageSize = this.paginationPageSize;
    this.paginationPageSize = Number(value);
    this.gridApi.paginationSetPageSize(this.paginationPageSize)

    var totalPages = this.data.TotalCount / this.paginationPageSize;
    if (Number(totalPages) === totalPages && totalPages % 1 !== 0) {
      totalPages = parseInt(totalPages.toString()) + 1;
    }

    var newCurrentPage = (this.oldPaginationPageSize * this.currentPage + 1) / this.paginationPageSize;
    if (Number(newCurrentPage) === newCurrentPage && newCurrentPage % 1 !== 0) {
      newCurrentPage = parseInt(newCurrentPage.toString());
    }

    this.currentPage = newCurrentPage;
    this.totalPages = totalPages;

    this.lazyLoadData();
  }

  sortChanged() {
    if (this.firstLoad && !this.IsGridEdit) {
      this.lazyLoadData();
      this.columns = this.gridColumnsChanged();
    } else if (this.IsGridEdit) {
      this.columnSettingChange.emit(this.gridColumnsChanged());
    }
  }

  columnEdited(event) {
    if (this.IsGridEdit) {
      this.columnSettingChange.emit(this.gridColumnsChanged());
    }
  }

  lazyLoadData() {
    this.startRow = this.paginationPageSize * this.currentPage;
    this.endRow = this.paginationPageSize * this.currentPage + this.paginationPageSize > this.data.TotalCount ? this.data.TotalCount : this.paginationPageSize * this.currentPage + this.paginationPageSize;

    var params = {
      startRow: this.startRow,
      endRow: this.endRow,
      sortModel: this.gridApi.getSortModel()
    }

    this.onLazyLoad.emit({ params, pageSize: this.paginationPageSize });
  }

  paginationChanged(event: any) {
  }

  onScroll(event: any) {

    if (event && !this.IsGridEdit) {
      this.setHeight();
      this.updateShadowState(event);
    }
  }

  onViewPortChanged(event: any) {
    this.setHeight();
  }

  onDragStarted(event: any) {
    this.isLeftShow = false;
    this.isRightShow = false;
  }

  onDragStopped(event: any) {
    this.columnEdited(event);
    this.onScroll(event);
  }

  onrowDataChanged(event: any) {
    this.showRightShadow();
  }

  showRightShadow() {
    var wrapper = this.getGridElement("ag-root-wrapper-body");
    var body = this.getGridElement("ag-body-container");

    if (!wrapper || !body) {
      return;
    }

    var wrapperWidth = wrapper.clientWidth;
    var bodyWidth = body.clientWidth;
    var leftPinnedCol = this.getGridElements("ag-pinned-left-cols-viewport");
    var rightPinnedCol = this.getGridElements("ag-pinned-right-cols-viewport");
    var leftPinnedColWidth = 0;
    var rightPinnedColWidth = 0;

    if (leftPinnedCol) {
      var leftPinnedElement = leftPinnedCol[0] as HTMLElement;

      if (leftPinnedElement) {
        leftPinnedColWidth = leftPinnedElement.clientWidth;
      }
    }
    if (rightPinnedCol) {
      var rightPinnedElement = rightPinnedCol[0] as HTMLElement;

      if (rightPinnedElement) {
        rightPinnedColWidth = rightPinnedElement.clientWidth;
      }
    }

    var scrollableWidth = wrapperWidth - leftPinnedColWidth - rightPinnedColWidth;

    this.setHeight();

    if (!this.IsGridEdit) {
      if (scrollableWidth < bodyWidth) {
        this.isRightShow = true;
      }
      else {
        this.isRightShow = false;
      }
    }
  }

  updateShadowState(event?: any) {
    var wrapper = this.getGridElement("ag-root-wrapper-body");
    var bodyViewport = this.getGridElement("ag-body-viewport");
    var body = this.getGridElement("ag-body-container");
    var horizontalOffset = event && typeof event.left === 'number' ? event.left : bodyViewport ? bodyViewport.scrollLeft : 0;

    if (!wrapper || !bodyViewport || !body) {
      return;
    }

    this.isLeftShow = horizontalOffset > 0;
    this.showRightShadow();

    if (bodyViewport.clientWidth >= body.clientWidth) {
      this.isLeftShow = false;
    }
  }

  setLeftShadow(): string {
    var leftPinnedElement = this.getGridElements("ag-pinned-left-cols-viewport");
    if (leftPinnedElement) {
      var leftPinnedRects = leftPinnedElement[0].getBoundingClientRect();
      var endrow = this.endRow ? this.endRow > 49 ? 96 : 99 : 99;
      var constantleft = leftPinnedRects.width + endrow;
      var style = "left:" + constantleft + "px;"
      return style;
    }

  }
  setRightShadow(): string {
    var rightPinnedElement = this.getGridElements("ag-pinned-right-cols-viewport");
    if (rightPinnedElement) {
      var rightPinnedRects = rightPinnedElement[0].getBoundingClientRect();
      var endrow = this.endRow ? this.endRow > 49 ? 56 : 51 : 51;
      if (rightPinnedRects.width > 0) {
        var constantRight = rightPinnedRects.width + 51;
      }
      else {
        constantRight = rightPinnedRects.width + endrow;
      }

      var style = "right:" + constantRight + "px;"
      return style;
    }

  }

  setHeight() {
    var body = this.getGridElement("ag-body-container");
    var viewPort = this.getGridElement("ag-body-viewport");
    var scrollArea0 = this.getHostElement("scroll-area", 0);
    var scrollArea1 = this.getHostElement("scroll-area", 1);

    if (!body || !viewPort || !scrollArea0 || !scrollArea1) {
      return;
    }

    var bodyHeight = body.clientHeight;
    var viewPortHeight = viewPort.clientHeight;
    var style = "";

    if (bodyHeight < viewPortHeight) {
      style = "height:" + bodyHeight + "px;"
    }
    else {
      style = "height:" + viewPortHeight + "px;"
    }
    var customLeft = style + this.setLeftShadow();
    var customRight = style + this.setRightShadow();

    scrollArea0.setAttribute("style", customLeft);
    scrollArea1.setAttribute("style", customRight);
  }

  private getGridElement(className: string, index: number = 0): HTMLElement {
    return this.getHostElement(className, index);
  }

  private getGridElements(className: string): HTMLCollectionOf<Element> {
    return this.hostElement.nativeElement.getElementsByClassName(className);
  }

  private getHostElement(className: string, index: number = 0): HTMLElement {
    return this.getGridElements(className)[index] as HTMLElement;
  }

}
